import React from 'react';
import { Grid, Hidden } from '@material-ui/core';
import MyContractsTabs from 'components/MyContractsTabs';
import MyContractInfo from 'components/MyContractInfo/AMCContractInfo';
import KnowMoreAboutContract from 'containers/AmcDetailsPage/MyContractAndGarantiesTab/KnowMoreAboutContracts';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { get } from 'lodash';
import MyBeneficiaries from './MyBeneficiaries';
import MyHealthCoverageBloc from './MyHealthCoverage';
const tabItems = (contracts: {}[]) =>
  contracts.map((contract) => ({
    label: get(contract, 'souscripteur', ''),
    content: (
      <MyContractInfo
        numPolice={get(contract, 'numeroPolice', '')}
        identification={get(contract, 'numCin', '')}
        paymentChoice={get(contract, 'modeReglement', '')}
        rib={get(contract, 'rib', '')}
        mandateAddress={get(contract, 'adresse', '')}
      />
    ),
    contractNumber: 'string',
    circulationDate: 'string',
  }));

const coverages = [
  {
    title: 'Optique',
    description: 'Desc Optique : ...',
  },
  {
    title: 'Hospitalisation',
    description: 'Desc Hospitalisation : ...',
  },
  {
    title: 'Césarienne',
    description: 'Desc Césarienne : ...',
  },
];

const MyContractAndGarantiesTab = (props: {
  intl: IntlShape;
  contractAMCDetails: [];
  contracts: any;
  beneficiaries: any;
}) => (
  <GaLoadHOC
    category={EVENT_CATEGORIES.AMC_DETAILS}
    label="Mes contrats_Tab 2_Mes contrats"
  >
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Hidden xsDown>
          <KnowMoreAboutContract />
        </Hidden>
        <MyContractsTabs
          tabItems={tabItems(props.contractAMCDetails)}
          getDetailContract={() => {}}
          isLoadingDetailContract={false}
          category=""
          label=""
        />
      </Grid>
      <Grid item xs={12}>
        <MyBeneficiaries beneficiaries={props.beneficiaries} />
      </Grid>
      <Grid item xs={12}>
        <MyHealthCoverageBloc
          coverages={coverages}
          isLoadingDetailContract={false}
        />
      </Grid>
    </Grid>
  </GaLoadHOC>
);

const mapStateToProps = createStructuredSelector<any, {}>({});
const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MyContractAndGarantiesTab));
